import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';
import SiteNavItem from './SiteNavItem';

import styles from './SiteNav-style.scss';

export function SiteNav({ viewer }) {
    const navigation = get(viewer, 'tradeNavigation') || get(viewer, 'navigation') || null;
    return (
        <nav>
            <ul className={styles.items}>
                {(get(navigation, 'modules') || []).map((module, index) => {
                    return (
                        <SiteNavItem
                            key={`nav-${module.serviceId}-position-${index}`}
                            navigationModule={module}
                        />
                    );
                })}
            </ul>
        </nav>
    );
}

SiteNav.propTypes = {
    viewer: PropTypes.object,
};

export default createFragmentContainer(SiteNav, {
    viewer: graphql`
        fragment SiteNav_viewer on Viewer {
            navigation: navigation(rootId: $previewKey) @include(if: $fetchNav) {
                modules {
                    ...SiteNavItem_navigationModule
                    serviceId
                }
            }
            tradeNavigation: navigation(rootId: $previewKey, userType: TRADE)
            @include(if: $fetchTradeNav) {
                modules {
                    ...SiteNavItem_navigationModule
                    serviceId
                }
            }
        }
    `,
});
